import React from 'react';
import './HotSpot.css';

const HotSpot = ({ sku, x, y, onChange, ...props }) => {
  return (
    <div
      className={'hotspot'}
      style={{
        left: x,
        top: y
      }}
      {...props}
    >
      {sku && (
        <input
          onChange={evt => onChange({ sku, value: evt.target.value })}
          value={sku}
        />
      )}
    </div>
  );
};

export default HotSpot;



// WEBPACK FOOTER //
// ./src/components/library/LookBook/HotSpot.js